import React, { useState } from "react";
import { Event } from "../core/lib/types";               
import { Dialog, DialogBackdrop, DialogPanel } from '@headlessui/react'
import '../App.css';
import {  formatTimeAMPM } from '../core/lib/utils';
import { useLocation } from "react-router-dom";
import Auth from '../core/services/auth';

function EventComponent({ id, title, media, location, vendor,
    createdAt, description, date, category, categoryId, setOpen, form, deleteEvent }: Event) {
    //
    const { state } = useLocation();
    const { name } = state || {};
    const [ openPersonal, setOpenPersonal ] = useState(false)
    
    const _vendor = Auth.getVendor().find((e: { name: any; })=>e.name === name)

    const editEvent = () => {

      //
      setOpen(true)
      //
      const cat = form.categories.data.find((c: { id: null; })=>c.id === categoryId)
      //
      form.setEventId(id)
      form.setTitle(title)
      form.setDescription(description)
      form.setCategory(cat.parent.id)
      setTimeout(()=>{
        form.setSubCategory(categoryId)
      }, 500)
      
      form.setDate(new Date(date))
    }
  
    //
    return (
              <div key={id}>
                <div className='flex flex-col'>
                          
                            
                            { media.type  === 'image' ?
                              <img onClick={e=>setOpenPersonal(true)} style={{ objectFit: 'cover'}}  className=" aspect-square relative h-auto max-w-full rounded-xl" src={media.url} alt=""/>
                              : ''
                            }
                            <div className="flex flex-col text-left pt-3 pb-2 pl-2">
                              <p onClick={e=>setOpenPersonal(true)} className="text-sm ">{title.length > 37 ? title.substring(0,37).concat(' ...') : title}</p>
                              <span onClick={e=>setOpenPersonal(true)} className="text-xs text-slate-600 pt-2.5 text-yellow-800">
                              { new Date(date).toDateString().substring(4)} • { formatTimeAMPM(date) }
                              </span>
                              <span onClick={e=>setOpenPersonal(true)} className="text-xs font-light text-gray-400">{vendor?.name}</span>
                              { category &&
                              <div className="relative py-2 mb-5">

                                <div onClick={e=>setOpenPersonal(true)} className="start-0 w-32 absolute "> 
                                  <span className=" relative w-max items-center justify-items-center py-1 px-2.5 bg-yellow-800 mt-2 text-xs font-medium text-white focus:outline-none rounded-full dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">  
                                    { category ? category.name : '' }
                                      
                                  </span>
                                </div>
                                { _vendor && 
                                  <div className="text-dark rounded-full end-0 absolute ">
                                    <button  type="button" onClick={e=>editEvent()} className="relative w-max items-center justify-items-center py-1 px-2.5 bg-white border border-yellow-800  text-xs font-medium text-dark focus:outline-none rounded-full dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700 mr-2">  
                                      edit
                                    </button>
                                    <button  type="button" onClick={e=>deleteEvent(id)} className="relative w-max items-center justify-items-center py-1 px-2.5 bg-white border border-yellow-800  text-xs font-medium text-dark focus:outline-none rounded-full dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">  
                                      delete
                                    </button>
                                  </div>
                                }

                              </div>
                                
                              }

                              { (!category && _vendor ) && 

                              <div className="text-dark rounded-full  start-0">
                                  <button  type="button" onClick={e=>editEvent()} className="relative w-max items-center justify-items-center py-1 px-2.5 bg-white border border-yellow-800  text-xs font-medium text-dark focus:outline-none rounded-full dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700 mr-2">  
                                    edit
                                  </button>
                                  <button  type="button" onClick={e=>deleteEvent(id)} className="relative w-max items-center justify-items-center py-1 px-2.5 bg-white border border-yellow-800  text-xs font-medium text-dark focus:outline-none rounded-full dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">  
                                    delete
                                  </button>
                                </div>

                              }
                              
                            </div>

                        </div> 
                        <Dialog id={title} open={openPersonal} onClose={setOpenPersonal} className="relative z-50">
                          <DialogBackdrop
                            transition
                            className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
                          />

                          <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                            <div className="flex min-h-full items-end justify-center text-center sm:items-center sm:p-0 ">
                              <DialogPanel
                                transition
                                className="relative w-full transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full sm:max-w-lg data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95 dark:bg-gray-800 dark:text-white"
                              >

                                <div className="p-3">
                                {/* <button onClick={e=>setOpenPersonal(false)} type="button" className="text-dark w-15 h-15 rounded-full absolute end-0 flex z-20 p-2 mr-2">
                                    <svg className="w-5 h-5" fill='currentColor' focusable="false" aria-hidden="true" viewBox="0 0 24 24" data-testid="CloseIcon"><path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path></svg>
                                </button> */}
                                <div className="text-dark w-15 h-15 rounded-full absolute end-0 flex z-20 p-2 mr-2">
                                  <button  type="button" onClick={e=>setOpenPersonal(false)} className="relative w-max items-center justify-items-center py-2 px-3.5 bg-yellow-800  text-xs font-medium text-white focus:outline-none rounded-full dark:focus:ring-gray-700 dark:bg-black dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">  
                                    close
                                  </button>
                                </div>
                                
                                  { media.type  === 'image' ?
                                    <img className="relative h-auto max-w-full rounded-lg" src={media.url} alt=""/>
                                    : ''
                                  }
                                  <div className="flex flex-col text-left pt-3 pb-8 pl-2">
                                    <span className="text-sm text-slate-500 pt-2.5 ">
                                    { new Date(date).toDateString().substring(0,3)}, { new Date(date).toDateString().substring(4)} • { formatTimeAMPM(date) }
                                    </span>
                                    <p className="text-md font-medium">{ title }</p>
                                    
                                    <span className="text-sm font-light text-gray-500 pt-2.5">{location?.name}</span>
                                    
                                    <div style={{whiteSpace: 'pre-line'}} className="pt-5 font-normal pb-10">{description}</div>
                                    
                                  </div>
                                </div>
                                
                              </DialogPanel>
                            </div>
                          </div>
                        </Dialog>  
        </div>             

   

    )
}

export default EventComponent